import { jsx as F } from "react/jsx-runtime";
import { useContext as c, useMemo as g, useEffect as I } from "react";
import { R as M } from "../../../LoadingSuspense-BdXYIsHy.js";
import { getErrorTypeMessage as x } from "./helpers/getErrorTypeMessage.js";
import "../../../index-2QXL0WYc.js";
import "../../../fuzzysort-eoXOpoo6.js";
import "../../Badge/Badge.js";
import "../../ButtonGroup/ButtonGroupProvider.js";
import "../../Card/Card.js";
import "../../CheckboxGroup/CheckboxGroup.js";
import "../../Col/Col.js";
import "../../Expander/Expander.js";
import { FormContext as E } from "../FormContext.js";
import { transformCustomRulesToValidateRule as y } from "./helpers/transformCustomRulesToValidateRule.js";
import "../../Menu/Menu.js";
import "../../Menu/MenuProvider.js";
import "../../Popover/PopoverProvider.js";
import "../../CheckboxMark/CheckboxMark.types.js";
import "../../CheckboxMark/CheckboxMark.js";
import "../../Modal/ModalProvider.js";
import "../../Panel/Panel.js";
import "../../Popover/Popover.js";
import "../../Popover/InputPopover/InputPopover.js";
import "../../Slideout/SlideoutProvider.js";
import "react-dom";
import "../../RadioGroup/RadioGroup.js";
import "../../Text/Text.js";
import "../../Skeleton/Skeleton.js";
import "../../SkipLink/SkipLink.js";
import "../../Stack/Stack.js";
import "../../Table/TableContext.js";
import "../../TabSet/Tab/Tab.js";
import "../../TabSet/TabSet.js";
import "../../Toggle/Toggle.js";
import "../../Tooltip/Tooltip.js";
import "../../ValidationMessage/ValidationMessage.js";
import { IressFieldGroup as q } from "../../Field/FieldGroup/FieldGroup.js";
const pr = ({
  control: d,
  defaultValue: n,
  name: o,
  render: f,
  rules: e,
  shouldUnregister: a,
  ...l
}) => {
  const r = c(E);
  if (!r)
    throw new Error(
      "IressFormFieldset must be used inside an IressForm. If you need a standalone field, use IressFieldGroup instead."
    );
  const t = e ? y(e) : void 0, { field: u, fieldState: i } = M({
    control: d,
    defaultValue: n,
    name: o,
    rules: t,
    shouldUnregister: a
  }), m = g(
    () => {
      var p, s;
      return i.error ? x(
        (p = i.error) == null ? void 0 : p.message,
        (s = i.error) == null ? void 0 : s.type,
        e
      ) : "";
    },
    [i, e]
  );
  return I(() => {
    r.setErrorMessage(o, m);
  }, [m, r, o]), /* @__PURE__ */ F(
    q,
    {
      errorMessages: m ? [{ message: m }] : void 0,
      required: !!(t != null && t.required),
      ...l,
      children: f({ ...u, id: `${r == null ? void 0 : r.id}__${o}` })
    }
  );
};
export {
  pr as IressFormFieldset
};
